<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3 bg-light">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/meeting">Meeting</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Crea il meeting
          </li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <!-- End .breadcrumb-nav -->

    <LoadedComponent :loading="loading" :percentual="percentual" />

    <div class="checkout" v-if="!loading">
      <div class="container">
        <div class="row pb-4">
          <div class="col-lg-12">
            <!-- End .checkout-title -->
            <form class="pt-4 pr-4 pl-4" @submit.prevent="create_meeting" id="create-meeting">
              <div class="card mb-4">
                <div class="card-header text-dark">DATI DEL MEETING</div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                      <ul>
                        <li v-for="(errorMessage, key) in errors" :key="key">
                          <div class="alert alert-danger">
                            {{ errorMessage[0] }}
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="col-sm-8">
                      <label for="nome_caso">Titolo del meeting
                        <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="nome_caso" placeholder="Scrivi il titolo del meeting"
                        v-model="meeting.activity.name" required />
                    </div>
                    <!-- End .col-sm-6 -->

                    <div class="col-sm-4">
                      <label for="select2Multiple">Autore <span class="text-danger">*</span></label>
                      <select class="js-example-basic-single form-control" name="autore_id" v-model="meeting.author_id"
                        required>
                        <option v-for="user in users" :key="user.id" :value="user.id">
                          {{ user.full_name }}
                        </option>
                      </select>
                      <div class="alert alert-danger" v-if="errors.author_id">
                        {{ errors.author_id[0] }}
                      </div>
                    </div>
                    <!-- End .col-sm-6 -->

                    <div class="col-md-6">
                      <label for="date_inizio">Data ora inizio <span class="text-danger">*</span>
                      </label>
                      <input type="datetime-local" id="meeting-time" class="form-control"
                        v-model="meeting.datetime_start" :min="meeting.datetime_start" required />

                      <div class="alert alert-danger" v-if="errors.datetime_start">
                        {{ errors.datetime_start[0] }}
                      </div>
                    </div>

                    <div class="col-md-6">
                      <label for="date_inizio">Data ora fine <span class="text-danger">*</span></label>

                      <input type="datetime-local" id="meeting-time" class="form-control" v-model="meeting.datetime_end"
                        :min="meeting.datetime_end" required />
                      <div class="alert alert-danger" v-if="errors.datetime_end">
                        {{ errors.datetime_end[0] }}
                      </div>
                    </div>

                    <div class="col-md-12" v-if="companies.length > 0">
                      <label for="company_edit" class="form-label">Azienda
                      </label>
                      <select class="form-control" id="company_edit" name="company_id"
                        v-model="meeting.activity.company_id">
                        <option :value="null" selected>Nessuno sponsor</option>
                        <option v-for="company in companies" :key="company.id" :value="company.id">
                          {{ company.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.activity && errors.activity.company_id">
                        {{ errors.activity.company_id[0] }}
                      </div>
                    </div>

                    <div class="col-md-12 text-center">
                      <h6>Opzione registrazione</h6>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="register" v-model="meeting.register"
                          id="meeting_not_registered" :value="false" />
                        <label class="form-check-label" for="meeting_not_registered">Non registrare il meeting (Al
                          termine verrà eliminato
                          in automatico)</label>
                      </div>
                      <div class="form-check form-check-inline mr-4">
                        <input class="form-check-input" type="radio" name="register" v-model="meeting.register"
                          id="meeting_registered" :value="true" />
                        <label class="form-check-label" for="meeting_registered">Registra il meeting</label>
                      </div>
                    </div>

                    <div class="col-sm-12 mt-2">
                      <label for="descrizione">Descrizione del meeting </label>
                      <textarea class="form-control" id="descrizione" rows="3" name="descrizione"
                        placeholder="Spiegazione del tuo post" v-model="meeting.activity.description"></textarea>

                      <div class="alert alert-danger" v-if="errors.activity && errors.activity.description">
                        {{ errors.activity.description[0] }}
                      </div>
                    </div>
                  </div>

                  <!--<div class="row flex-column pb-2 pl-2 pr-2">
                    <div class="flex-row">
                      <button type="submit" class="btn btn-primary float-right">
                        Pubblica il meeting <i class="las la-save"></i>
                      </button>
                    </div>
                  </div>-->
                </div>
              </div>

              <div class="card mb-4">
                <div class="card-header text-dark">COPERTINA</div>
                <div class="card-body">
                  <div class="col-sm-12 mt-2">
                    <div class="input-group mb-3">
                      <div class="custom-file">
                        <input type="file" class="custom-file-input" name="link_2" @change="handleFileUpload"
                          id="link_2" aria-describedby="inputGroupFileAddon01" />
                        <label class="custom-file-label text-center" for="link_2" id="labelsfiles">{{ nameFiles
                          }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card mb-4">
                <div class="card-header text-dark">
                  ACCESSIBILITA' AL MEETING
                </div>
                <div class="card-body">
                  <div class="col-md-12 text-center">
                    <h6>Accesso al meeting da relatori</h6>
                    <div class="form-check form-check-inline mr-4">
                      <input class="form-check-input" type="radio" name="relatori" v-model="meeting.options.allspeakers"
                        @change="relatoriCheckbox" id="checkbox_accessible_to_all_relators" :value="true" />
                      <label class="form-check-label" for="checkbox_accessible_to_all_relators">Tutti gli utenti come
                        relatori</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="relatori" v-model="meeting.options.allspeakers"
                        id="checkbox_accessible_limit" @change="relatoriCheckbox" :value="false" />
                      <label class="form-check-label" for="checkbox_accessible_limit">Voglio selezionare i relatori del
                        meeting</label>
                    </div>
                    <div class="font-italic">
                      (I relatori sono gli utenti che partecipano al meeting
                      potendo intervenire con webcam e microfono)
                    </div>
                  </div>

                  <div class="col-md-12 text-center mt-2" v-show="meeting.options.allspeakers == false">
                    <h6>Accesso al meeting da partecipanti</h6>
                    <div class="form-check form-check-inline mr-4">
                      <input class="form-check-input" type="radio" name="accessible"
                        v-model="meeting.options.allparticipants" @change="invitatiCheckbox" :value="true" />
                      <label class="form-check-label">Rendi il meeting accessibile a tutti</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="accessible"
                        v-model="meeting.options.allparticipants" @change="invitatiCheckbox" :value="false" />
                      <label class="form-check-label" for="checkbox_accessible_limit">Limita l'accesso al caso
                        selezionando gli utenti</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row flex-column pb-2 pl-2 pr-2">
                <div class="flex-row">
                  <button type="submit" class="btn btn-primary float-right">
                    Pubblica il meeting <i class="las la-save"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
      id="relatori-group">
      <div class="modal-dialog modal-xl" role="document" style="max-width: 90%">
        <div class="modal-content">
          <div class="modal-header">
            <div class="w-100">
              <h5 class="modal-title text-center">
                Seleziona gli utenti o i gruppi
              </h5>
            </div>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-news">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body p-4">
            <div class="w-100 text-center">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="users_group_checkbox"
                  v-model="meeting.options.partecipants.type" :value="'group'" />
                <label class="form-check-label" for="users_group_checkbox">Seleziona un gruppo di utenti</label>
              </div>

              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="all_users_checkbox"
                  v-model="meeting.options.partecipants.type" :value="'user'" />
                <label class="form-check-label" for="all_users_checkbox">Seleziona gli utenti singolarmente</label>
              </div>

              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="new_groups" v-model="meeting.options.partecipants.type"
                  :value="''" />
                <label class="form-check-label" for="new_groups">Crea un nuovo gruppo</label>
              </div>
            </div>

            <div class="row" v-if="meeting.options.partecipants.type == 'group'">
              <div class="col-md-3" v-for="group in groups" :key="group.id">
                <ul>
                  <li>
                    <div class="icheck-wetasphalt mt-3">
                      <input type="checkbox" :id="'checkbox-group-' + group.id"
                        v-model="meeting.options.partecipants.groups" :value="group.id" />
                      <label :for="'checkbox-group-' + group.id">{{ group.name }} (Numero utenti:
                        {{ group.numbers_users }})
                      </label>
                    </div>
                  </li>
                </ul>
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button"
                    :id="'dropdownMenuButton-group-' + group.id" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    Guarda gli utenti del gruppo
                  </button>
                  <div class="dropdown-menu" :aria-labelledby="'dropdownMenuButton-group-' + group.id">
                    <a class="dropdown-item" href="#" v-for="user in group.users" :key="user.id">
                      {{ user.name }} {{ user.lastname }}
                    </a>
                  </div>
                </div>
              </div>
              <div class="w-100 text-right">
                <button type="button" class="btn btn-primary" @click="confirm_group_users('relatori-group')">
                  Conferma
                </button>
              </div>
            </div>

            <div v-if="meeting.options.partecipants.type == ''">
              <form class="needs-validation" @submit.prevent="create_group">
                <div class="col-md-12 mb-3">
                  <label for="name_group">Nome del gruppo</label>
                  <input type="text" class="form-control" id="name_group" v-model="newgroup.name"
                    placeholder="Scrivi il nome del gruppo" />
                  <div class="bg-info text-secondary p-2" v-if="errors_group.name">
                    {{ errors_group.name[0] }}
                  </div>
                </div>

                <div class="col-md-12">
                  <h6 class="text-center">Seleziona gli utenti</h6>
                  <div class="bg-info text-secondary p-2" v-if="errors_group.users">
                    {{ errors_group.users[0] }}
                  </div>
                  <div class="row">
                    <div class="col-md-3" v-for="user in users" :key="user.id">
                      <ul>
                        <li>
                          <div class="icheck-wetasphalt mt-3">
                            <input type="checkbox" :id="'chb1-' + user.id" v-model="newgroup.users" :value="user.id" />
                            <label :for="'chb1-' + user.id">{{
                              user.full_name
                              }}</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="w-100 text-right">
                  <button type="submit" class="btn btn-primary">
                    Salva il gruppo
                  </button>
                </div>
              </form>
            </div>

            <div v-if="meeting.options.partecipants.type == 'user'">
              <div class="row">
                <div class="col-md-3" v-for="user in users" :key="user.id">
                  <ul>
                    <li>
                      <div class="icheck-wetasphalt mt-3">
                        <input type="checkbox" :id="'checkbox-' + user.id"
                          v-model="this.meeting.options.partecipants.users" :value="user.id" />
                        <label :for="'checkbox-' + user.id">{{
                          user.full_name
                          }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="w-100 text-right">
                <button type="button" class="btn btn-primary" data-dismiss="modal">
                  Conferma
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
      id="invitations-group">
      <div class="modal-dialog modal-xl" role="document" style="max-width: 90%">
        <div class="modal-content">
          <div class="modal-header">
            <div class="w-100">
              <h5 class="modal-title text-center">
                Seleziona gli utenti o i gruppi
              </h5>
            </div>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
              id="close-modal-delete-invitations">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body p-4">
            <div class="w-100 text-center">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="checkbox_group" id="users_group_checkbox_invitations"
                  v-model="meeting.options.invitations.type" :value="'group'" />
                <label class="form-check-label" for="users_group_checkbox_invitations">Seleziona un gruppo di
                  utenti</label>
              </div>

              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="checkbox_group" id="all_users_checkbox_invitations"
                  :value="'user'" v-model="meeting.options.invitations.type" />
                <label class="form-check-label" for="all_users_checkbox_invitations">Seleziona gli utenti
                  singolarmente</label>
              </div>

              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="checkbox_group" id="new_groups_invitations"
                  :value="''" v-model="meeting.options.invitations.type" />
                <label class="form-check-label" for="new_groups_invitations">Crea un nuovo gruppo</label>
              </div>
            </div>

            <div class="row" v-if="meeting.options.invitations.type == 'group'">
              <div class="col-md-3" v-for="group in groups" :key="group.id">
                <ul>
                  <li>
                    <div class="icheck-wetasphalt mt-3">
                      <input type="checkbox" :id="'checkbox-group-invitations' + group.id"
                        v-model="meeting.options.invitations.groups" :value="group.id" />
                      <label :for="'checkbox-group-invitations' + group.id">{{ group.name }} (Numero utenti:
                        {{ group.numbers_users }})
                      </label>
                    </div>
                  </li>
                </ul>
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button"
                    :id="'dropdownMenuButton-invitations-group-' + group.id" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    Guarda gli utenti del gruppo
                  </button>
                  <div class="dropdown-menu" :aria-labelledby="'dropdownMenuButton-invitations-group-' + group.id
                    ">
                    <span class="dropdown-item" v-for="user in group.users" :key="user.id">
                      {{ user.name }} {{ user.lastname }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="w-100 text-right">
                <button type="button" class="btn btn-primary" @click="confirm_group_users('invitations-group')">
                  Conferma
                </button>
              </div>
            </div>

            <div v-if="meeting.options.invitations.type == ''">
              <form class="needs-validation" @submit.prevent="create_group">
                <div class="col-md-12 mb-3">
                  <label for="name_group">Nome del gruppo</label>
                  <input type="text" class="form-control" id="name_group_invitations" v-model="newgroup.name"
                    placeholder="Scrivi il nome del gruppo" />
                  <div class="bg-info text-secondary p-2" v-if="errors_group.name">
                    {{ errors_group.name[0] }}
                  </div>
                </div>

                <div class="col-md-12">
                  <h6 class="text-center">Seleziona gli utenti</h6>
                  <div class="bg-info text-secondary p-2" v-if="errors_group.users">
                    {{ errors_group.users[0] }}
                  </div>
                  <div class="row">
                    <div class="col-md-3" v-for="user in users" :key="user.id">
                      <ul>
                        <li>
                          <div class="icheck-wetasphalt mt-3">
                            <input type="checkbox" :id="'chb1-invitations' + user.id" v-model="newgroup.users"
                              :value="user.id" />
                            <label :for="'chb1-invitations' + user.id">{{
                              user.full_name
                              }}</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="w-100 text-right">
                  <button type="submit" class="btn btn-primary">
                    Salva il gruppo
                  </button>
                </div>
              </form>
            </div>

            <div v-if="meeting.options.invitations.type == 'user'">
              <div class="row">
                <div class="col-md-3" v-for="user in users" :key="user.id">
                  <ul>
                    <li>
                      <div class="icheck-wetasphalt mt-3">
                        <input type="checkbox" :id="'checkbox-invitations' + user.id"
                          v-model="this.meeting.options.invitations.users" :value="user.id" />
                        <label :for="'checkbox-invitations' + user.id">{{
                          user.full_name
                          }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="w-100 text-right">
                <button type="button" class="btn btn-primary" data-dismiss="modal">
                  Conferma
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import httpservices from "@/services/httpservices.js";
import router from "@/router";

import { useAuth } from "@/stores/auth.js";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
export default {
  name: "CreateMeeting",
  components: {
    LoadedComponent,
  },
  props: [],
  data() {
    return {
      meeting: {
        activity: {
          name: "",
          description: "",
          company_id: null,
        },
        options: {
          allspeakers: true,
          allparticipants: false,
          partecipants: { users: [], type: "group", groups: [] },
          invitations: { users: [], type: "group", groups: [] },
        },
        author_id: 0,
        datetime_start: new Date(),
        datetime_end: new Date(),
        register: true,
      },
      groups: [],
      newgroup: {
        name: "",
        description: "",
        users: [],
      },
      formatting_date_start: "",
      formatting_date_end: "",
      users: [],
      companies: [],
      authors: [],
      errors: [],
      messageErrorAttachments: "",
      loading: false,
      errors_group: {},
      nameFiles:
        "Seleziona un immagine di copertina per questo meeting (png, jpg, jpeg)",
      selectedFile: null,
      percentual: 0,
    };
  },
  mounted() {
    this.loadCompanies();
    this.fetchUsers();
    this.fetchGroups();

    // Formatta la data e l'ora attuali nel formato corretto per datetime-local
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Aggiungi un 0 se il mese è inferiore a 10
    const day = String(now.getDate()).padStart(2, "0"); // Aggiungi un 0 se il giorno è inferiore a 10
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    this.meeting.datetime_end =
      year + "-" + month + "-" + day + " " + hours + ":" + minutes;
    this.meeting.datetime_start =
      year + "-" + month + "-" + day + " " + hours + ":" + minutes;
  },

  methods: {
    confirm_group_users(modal) {
      $("#" + modal).modal("hide");
    },
    async upload_attachments(id) {
      await httpservices
        .uploadAttachments(
          this.selectedFile,
          id,
          "meeting",
          0,
          (percentCompleted) => {
            this.percentual = percentCompleted;
            // Puoi fare qualcosa con il valore percentCompleted qui
          }
        )
        .then(() => {
          this.loading = false;
          this.nameFiles = "Scegli i file (MAX 1 GIGA)";

          router.push("/meeting");
        })
        .catch((error) => {
          if (error.response.data.message)
          {
            localStorage.setItem(
              "messageErrorMeeting",
              error.response.data.message
            );
          }
        });
    },
    async loadCompanies() {
      await httpservices
        .getCompany()
        .then((response) => {
          this.companies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchGroups() {
      this.loading = true;
      await httpauth
        .get("/groups")
        .then((response) => {
          this.groups = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async create_group() {
      await httpauth
        .post("/groups", this.newgroup)
        .then((response) => {
          if (response.data.status)
          {
            this.newgroup = {
              name: "",
              description: "",
              users: [],
            };
            this.fetchGroups();
            const $toast = useToast();
            $toast.open({
              message: response.data.message,
              type: "success",
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          } else if (error.response.data.errors)
          {
            this.errors_group = error.response.data.errors;
            console.log(this.errors_group);
          }
        });
    },
    invitatiCheckbox() {
      console.log(this.meeting.options.allparticipants);
      if (this.meeting.options.allparticipants == true)
      {
        $("#invitations-group").modal("hide");
        return;
      }
      $("#invitations-group").modal("show");
    },
    relatoriCheckbox() {
      if (this.meeting.options.allspeakers == true)
      {
        $("#relatori-group").modal("hide");
        this.meeting.options.allparticipants = false;
      } else
      {
        this.meeting.options.allparticipants = true;
        $("#relatori-group").modal("show");
      }
    },
    async create_meeting() {
      this.loading = true;
      this.percentual = 0;

      await httpauth
        .post("/meetings", this.meeting)
        .then((response) => {
          if (response.data.status == false)
          {
            this.loading = false;
            const $toast = useToast();
            $toast.open({
              message: response.data.message,
              type: "warning",
              position: "top-right",
            });
            return;
          }
          localStorage.setItem("messageSuccessMeeting", response.data.message);
          if (this.selectedFile != null)
          {
            console.log(response.data);
            this.upload_attachments(response.data.data.id);
            return;
          }
          this.loading = false;
          router.push("/meeting");
        })
        .catch((error) => {
          this.loading = false;
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }

          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = event.target.files[0];
      const totalSize = files.size;
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (totalSize <= maxSize)
      {
        if (
          !allowedTypes.includes(files.type) ||
          !httpservices.checkDicom(files)
        )
        {
          alert("Per favore seleziona un file valido (JPEG/JPG/PNG).");
          this;
          return;
        }
        this.nameFiles = files.name;
        this.selectedFile = files;
      } else
      {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
    async fetchUsers() {
      await httpservices
        .getUsers()
        .then((response) => {
          this.users = response.data.data;
          const auth = useAuth();

          const user = {
            id: auth.user.id,
            full_name: "Me stesso/a",
          };
          this.meeting.author_id = auth.user.id;
          this.users.unshift(user);
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
  },
};
</script>
<style>
.dp__input {
  height: 40px !important;
  font-size: 15px !important;
}

.dp__icon {
  width: 15px !important;
  height: 15px !important;
}

.dp__cell_inner {
  font-size: 15px;
}

.dp__calendar_header_item {
  font-size: 13px;
}

.dp__month_year_select {
  font-size: 13px !important;
}

.dp__action_button {
  font-size: 15px;
}

.dp__selection_preview {
  font-size: 12px;
}
</style>